export default __webpack_public_path__ + "static/media/northern_cyprus.e44d5937.svg";